import { Sequential as SequentialScale } from '@antv/scale';
export var Sequential = function Sequential(options) {
  return new SequentialScale(options);
};
Sequential.props = {};